$(function() {

	var $links = $(".menu-left__items").find("a");

	var list = $links.map(function(){ return $(this).attr("href") }).get();

	if (list.length == 0) return false;

	var text = list.toString();

	var remove = text.replace(new RegExp("#","g"),"");

	var array = remove.split(",");

	var sections = {};

	function setSections() {
		$(array).each(function (index, element) {
			var $section = $(".content-new__obsah").find("a[name='" + element + "']");

			sections[element] = {
				$section: $section,
				position: $section.position()
			};
		});
	}

	var $document = $("html");

	$(window).on("load resize", setSections);

	$(window).scroll(function () {

		if ($.isEmptyObject(sections)) {
			setSections();
		}

		var current = '';

		$(array).each(function (index, element) {

			var section = sections[element];

			if ($document.scrollTop() >= section.position.top - 2) {

				current = element;

			}

		});

		if (current != '') {

			$links.removeClass("on");

			$links.filter("[href='#"+current+"']").addClass('on');

		}

	});

});
